export default "__VITE_ASSET__dc7065de__"